import { useState, useEffect } from "react";
import { Gamepad2, Users, Zap } from "lucide-react";

interface StatItemProps {
  icon: React.ReactNode;
  value: number | string;
  label: string;
  color: string;
}

const StatItem = ({ icon, value, label, color }: StatItemProps) => {
  const [count, setCount] = useState(0);
  const targetValue = typeof value === 'number' ? value : 0;

  useEffect(() => {
    if (typeof value === 'number') {
      const duration = 2000;
      const steps = 60;
      const increment = targetValue / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= targetValue) {
          setCount(targetValue);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }
  }, [value, targetValue]);

  return (
    <div className={`cyber-card p-4 text-center hover:scale-110 transition-all duration-300 cursor-pointer group relative overflow-hidden`}>
      <div className={`absolute inset-0 bg-gradient-to-br from-${color}/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity`}></div>
      <div className="relative z-10">
        <div className="flex justify-center mb-2">
          {icon}
        </div>
        <div className={`text-${color} text-2xl font-bold font-cyber mb-1`}>
          {typeof value === 'number' ? count.toString().padStart(2, '0') : value}
        </div>
        <div className="text-foreground/60 text-base">{label}</div>
      </div>
      <div className={`absolute bottom-0 left-0 right-0 h-1 bg-${color} transform scale-x-0 group-hover:scale-x-100 transition-transform`}></div>
    </div>
  );
};

const InteractiveStats = () => {
  return (
    <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto pt-12 font-mono">
      <StatItem
        icon={<Gamepad2 className="w-6 h-6 text-primary" />}
        value={1}
        label="игр"
        color="primary"
      />
      <StatItem
        icon={<Users className="w-6 h-6 text-accent" />}
        value={4}
        label="разработчиков"
        color="accent"
      />
      <StatItem
        icon={<Zap className="w-6 h-6 text-secondary" />}
        value="∞"
        label="творчество"
        color="secondary"
      />
    </div>
  );
};

export default InteractiveStats;
